// extracted by mini-css-extract-plugin
module.exports = {"component":"_262aux9UP_rvntc46RaWZr"};